import { jsx } from "react/jsx-runtime";
import { Grid } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import styled from "styled-components";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import sortMediaQuery from "../../util/sort-media-query.esm.js";
const GridContent = /* @__PURE__ */ styled(Grid).withConfig({
  displayName: "GridContent",
  componentId: "sc-m3b162-0"
})(["flex-direction:column;"]);
const BlockGridContent = ({
  attrs,
  index,
  innerBlocks
}) => {
  const attributes = {
    backgroundColor: null,
    padding: "none",
    ...attrs,
    // Defaults
    gridColumnEnd: sortMediaQuery({
      default: "span 1",
      sm_lte: "span 12",
      ...attrs == null ? void 0 : attrs.gridColumnEnd
    })
  };
  return /* @__PURE__ */ jsx(
    GridContent,
    {
      ...attributes,
      display: "flex",
      children: generateBlockList({
        blocks: innerBlocks
      })
    },
    index
  );
};
BlockGridContent.propTypes = {
  attrs: PropTypes.shape({
    gridColumnEnd: PropTypes.shape({})
  }),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockGridContent as default
};
